module.exports = __webpack_public_path__ + "static/media/jose_lopez.f177d6ac.jpg";